import { createRef } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Toast, Loader } from '@vzmi/shp_shared_compo'
import SPBaseModule from '../../../../../lib/SPBaseModule'
import { pullLeft, pullRight } from '../../../../../styles/shared.css'
import { numeralFormat } from '../../../../../../lib/renderUtil'
import { HyperLink } from '../../../../Common/Form'
import Modal from '../../../../Common/NewDashboard/Modal/Modal'
import Table from '../../../../Common/NewDashboard/Table/Table'
import LoadingSpinner from '../../../../Common/LoadingSpinner/LoadingSpinner'
import errorHelper, { httpHandler } from '../../../../../../lib/errorHelper'
import safeAwait from '../../../../../../lib/safeAwait'
import { FIELD, FIELD_MAP } from '../constants'
import styles from './KeywordsListingDialog.css'

const MAX_LIMIT_PER_REQ = 10

const column = [
  {
    id: 'listingIdAndName',
    accessor: 'listingIdAndName',
    width: 268,
    headerClassName: cx(pullLeft, styles.col, styles.start),
    className: cx(pullLeft, styles.col, styles.start, styles.flexWrap),
    Header: `${FIELD_MAP[FIELD.LISTING_ID]}／${FIELD_MAP[FIELD.LISTING_NAME]}`,
    Cell: row => {
      const rowData = _.get(row, 'original', {})
      const listingId = rowData[FIELD.LISTING_ID]
      const listingName = rowData[FIELD.LISTING_NAME]
      return (
        <>
          <p className={styles.listingId}>
            <HyperLink
              target='_blank'
              href={`https://tw.buy.yahoo.com/gdsale/gdsale.asp?gdid=${listingId}`}
            >
              {listingId}
            </HyperLink>
          </p>
          <p className={styles.listingName}>{listingName}</p>
        </>
      )
    }
  },
  {
    id: FIELD.CLICKS,
    accessor: FIELD.CLICKS,
    width: 66,
    Header: FIELD_MAP[FIELD.CLICKS],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => numeralFormat(_.toNumber(row.value))
  },
  {
    id: FIELD.IMPRESSIONS,
    accessor: FIELD.IMPRESSIONS,
    width: 66,
    Header: FIELD_MAP[FIELD.IMPRESSIONS],
    headerClassName: cx(pullRight, styles.col, styles.end),
    className: cx(pullRight, styles.col, styles.end),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.CTR,
    accessor: FIELD.CTR,
    width: 66,
    Header: FIELD_MAP[FIELD.CTR],
    headerClassName: cx(pullRight, styles.col, styles.end),
    className: cx(pullRight, styles.col, styles.end),
    Cell: row => numeralFormat(row.value * 100, { allowZero: true, format: '0.00' })
  }
]

class KeywordsListingDialog extends SPBaseModule {
  constructor (props) {
    super(props)
    this.state = {
      visible: false,
      keyword: '',
      searchKeywordListings: [],
      resultsTotal: 0
    }
    this.infiniteScrollArea = createRef()
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      !prevState.visible &&
      this.state.visible &&
      // 首次產生 component 時 ref 是空的
      this.infiniteScrollArea.current
    ) {
      // 重新進入 dialog 重置 scrollbar
      this.infiniteScrollArea.current.scrollTop = 0
    }
  }

  onOpen = async (keyword) => {
    await new Promise(resolve => {
      this.setState(
        () => ({
          keyword,
          // 先清除前一次查詢結果在再次查詢，避免清掉前 reopen dialog 被 state 記下未清除的賣場
          searchKeywordListings: []
        }),
        resolve
      )
    })
    this.setState({ visible: true })
    const [errorMessage] = await this.loadListing(keyword)
    if (errorMessage) {
      Toast.error(errorMessage)
    }
  }

  onCancel = () => this.setState({ visible: false })

  onOk = () => this.onCancel()

  loadListing = async (keyword, offset = 0) => {
    const { fetchSpecificSearchKeywordListings } = this.props
    const { searchKeywordListings: currentListings } = this.state
    const [error, payload] = await safeAwait(
      fetchSpecificSearchKeywordListings({ keyword, offset, limit: MAX_LIMIT_PER_REQ }).then(httpHandler)
    )
    const errorMessage = errorHelper.parseErrorMessage(error)
    if (errorMessage) {
      return [errorMessage]
    }

    const loadedListings = _.get(payload, 'searchKeywordListings', [])
    const resultsTotal = _.get(payload, 'pagination.resultsTotal', 0)
    this.setState({
      searchKeywordListings: _.concat(currentListings, loadedListings),
      resultsTotal
    })
    this.setIsSuccess(true)
    return [undefined, payload]
  }

  loadmore = async () => {
    const { keyword, searchKeywordListings } = this.state
    const offset = _.size(searchKeywordListings)
    this.loadListing(keyword, offset)
  }

  render () {
    const {
      visible,
      isLoading,
      keyword,
      searchKeywordListings,
      resultsTotal
    } = this.state
    const dataSize = _.size(searchKeywordListings)
    return (
      <Modal
        title={`${keyword} 賣場清單`}
        visible={visible}
        onOk={this.onOk}
        onCancel={this.onCancel}
        footer={null}
        className={styles.KeywordsListingDialog}
      >
        <Loader loaded={!isLoading}>
          <div
            id='InfiniteScroll'
            ref={this.infiniteScrollArea}
            className={styles.infiniteScrollArea}
          >
            <InfiniteScroll
              dataLength={dataSize}
              next={this.loadmore}
              hasMore={dataSize < resultsTotal}
              loader={<LoadingSpinner />}
              scrollableTarget='InfiniteScroll'
            >
              <Table
                sortable={false}
                resizable={false}
                showPagination={false}
                data={searchKeywordListings}
                columns={column}
                pageSize={dataSize}
                className={styles.table}
                noBorder
              />
            </InfiniteScroll>
          </div>
        </Loader>
      </Modal>
    )
  }
}

export default KeywordsListingDialog
